import { useEffect, useRef } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import FormContainer from '../components/FormContainer';
import Loader from '../components/Loader';
import Message from '../components/Message';
import { useLineLoginCallbackMutation } from '../slices/usersApiSlice';
import { setCredentials } from '../slices/authSlice';

// LINE redirects here: /line/callback?code=...&state=...
// (or ?error=access_denied if the user pressed "Cancel" on LINE).
const LineCallbackScreen = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [lineCallback, { error }] = useLineLoginCallbackMutation();

  // An auth code works ONCE. React 18 StrictMode runs effects twice in dev,
  // so without this guard the 2nd call would fail with "invalid code".
  const sent = useRef(false);

  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const lineError = searchParams.get('error');

  useEffect(() => {
    if (sent.current || lineError || !code || !state) return;
    sent.current = true;

    (async () => {
      try {
        const { redirect, ...user } = await lineCallback({ code, state }).unwrap();
        dispatch(setCredentials({ ...user }));
        toast.success(`歡迎，${user.name}！`);
        navigate(redirect || '/', { replace: true });
      } catch (err) {
        toast.error(err?.data?.message || err.error);
      }
    })();
  }, [code, state, lineError, lineCallback, dispatch, navigate]);

  if (lineError || error || !code || !state) {
    return (
      <FormContainer>
        <h1>LINE 登入</h1>
        <Message variant="danger">
          {lineError ? '已取消 LINE 登入' : error?.data?.message || 'LINE 登入失敗，請再試一次'}
        </Message>
        <Link to="/login">返回登入頁</Link>
      </FormContainer>
    );
  }

  return (
    <FormContainer>
      <h1>LINE 登入中…</h1>
      <Loader />
    </FormContainer>
  );
};

export default LineCallbackScreen;
